import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"
import { AUDIO_COLORS } from './constants';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Color de un combo: explícito > primera regla > primer audio > null
export const getComboColorHex = (combo) => {
  if (combo?.color && AUDIO_COLORS[combo.color]) return AUDIO_COLORS[combo.color].hex;
  const ruleColor = combo?.rules?.[0]?.color;
  if (ruleColor && AUDIO_COLORS[ruleColor]) return AUDIO_COLORS[ruleColor].hex;
  const audioColor = combo?.audios?.[0]?.color;
  if (audioColor && AUDIO_COLORS[audioColor]) return AUDIO_COLORS[audioColor].hex;
  return null;
};

// Mensaje de error de micrófono según la causa (con guía para desbloquear en PC)
export const getMicErrorMessage = (err) => {
  if (typeof navigator !== 'undefined' && !navigator.mediaDevices?.getUserMedia) {
    return 'Este navegador no soporta grabación de audio. Usa Chrome, Edge o Firefox actualizado, o sube un archivo de audio.';
  }
  if (err?.name === 'NotAllowedError' || err?.name === 'PermissionDeniedError') {
    return 'El micrófono está bloqueado. Actívalo en el icono 🔒 de la barra de direcciones → Permisos → Micrófono → Permitir, e inténtalo de nuevo.';
  }
  if (err?.name === 'NotFoundError' || err?.name === 'DevicesNotFoundError') {
    return 'No se encontró ningún micrófono. Conecta uno o sube un archivo de audio.';
  }
  if (err?.name === 'NotReadableError') {
    return 'El micrófono está siendo usado por otra aplicación. Ciérrala e inténtalo de nuevo.';
  }
  return 'No se pudo acceder al micrófono. Revisa los permisos del navegador (icono 🔒 junto a la URL) o sube un archivo de audio.';
};
